module.exports = __webpack_public_path__ + "img/gnosis.dc5772f3.svg";